import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const SystemCallsModule = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="System Calls & System/Application Call Interface"
    videos={[
      "https://www.youtube.com/embed/d3aCjfuMCIU",
      "https://www.youtube.com/embed/MPxvzUNupNI",
      "https://www.youtube.com/embed/lhToWeuWWfw"
    ]}
    takeaways={[]}
    questions={[
      "What is a system call? Why are system calls necessary? Illustrate the methods to pass the parameters of system calls to the OS.",
      "Define system call and system programs and list its categories respectively."
    ]}
    exampleVideos={[]}
  />
);
}

export default SystemCallsModule;
